import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card'
import { Button } from '../../components/ui/button'
import {
  MessageSquare,
  HelpCircle,
  Calendar,
  MapPin,
  Clock
} from 'lucide-react'

export default function Help() {
  return (
    <div className="container mx-auto px-4 py-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Help & Support</h1>
        <p className="text-muted-foreground mt-2">
          Get assistance for IFTA 2025
        </p>
      </div>

      {/* Contact Support and Quick Help Grid */}
      <div className="grid gap-6 lg:grid-cols-2 mb-8">
        {/* Contact Support */}
        <Card className="bg-gradient-to-br from-green-50 to-emerald-50 border-green-200">
          <CardHeader className="pb-4">
            <div className="flex items-center gap-2">
              <MessageSquare className="h-5 w-5" />
              <CardTitle className="text-lg">Contact Support</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Demo Questions</h3>
              <p className="text-sm text-gray-600 mb-2">
                For questions about presentation format, technical requirements, and demo logistics.
              </p>
              <a href="mailto:maulika@indiafintech.com" className="text-sm font-medium text-blue-600 hover:underline">
                maulika@indiafintech.com
              </a>
              <p className="text-sm text-gray-600 mb-2">
              +91 98339 25027
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Sponsorship & Partnerships</h3>
              <p className="text-sm text-gray-600 mb-2">
                For sponsorship opportunities and strategic partnerships.
              </p>
              <a href="mailto:riny@indiafintech.com" className="text-sm font-medium text-blue-600 hover:underline">
                riny@indiafintech.com
              </a>
              <p className="text-sm text-gray-600 mb-2">
              +91 91379 29779
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Quick Help */}
        <Card className="bg-gradient-to-br from-green-50 to-emerald-50 border-green-200">
          <CardHeader className="pb-4">
            <div className="flex items-center gap-2">
              <HelpCircle className="h-5 w-5" />
              <CardTitle className="text-lg">Quick Help</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            <div>
              <h3 className="font-semibold text-gray-900 mb-3">Getting Started</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Complete your company profile</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Upload your presentation materials</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Assign networking passes to team members</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Review the event timeline and requirements</span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-gray-900 mb-3">Common Issues</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>File upload problems - Check file size and format</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Pass assignment - Ensure email addresses are correct</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Technical requirements - Contact support for special needs</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Schedule conflicts - Reach out as early as possible</span>
                </li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Event Information */}
      <Card className="bg-gradient-to-br from-green-50 to-emerald-50 border-green-200">
        <CardHeader className="pb-4">
          <CardTitle className="text-lg">Event Information</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-8 md:grid-cols-3">
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Event Date</h3>
              <p className="text-sm text-gray-600">December 10th, 2025</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Venue</h3>
              <p className="text-sm text-gray-600">Aurika, Mumbai</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Time</h3>
              <p className="text-sm text-gray-600">9:00 AM - 7:00 PM</p>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-green-200">
            <Button
              className="w-full md:w-auto"
              onClick={() => {
                // Create calendar event
                const event = {
                  title: 'IFTA 2025 - India FinTech Awards',
                  details: 'We look forward to welcoming you to IFTA 2025.\n\nEvent details:\nDate: 10th December 2025\nTime: 9am to 7pm IST\n\nVenue: Aurika, Mumbai (near Mumbai International Airport)\nAddress: CTS No. 145 A, NS C-04, Skycity, Chhatrapati Shivaji Maharaj International Airport Rd, near Mumbai International Airport, AAI Colony, J B Nagar, Andheri East, Mumbai, Maharashtra 400099\n\nMap Link: https://maps.app.goo.gl/GvetoCK2WEa9e69w6\n\nAgenda: https://www.indiafintech.com/agenda\n\nWarm regards,\nTeam IFTA',
                  location: 'Aurika Mumbai, Andheri East',
                  startDate: '2025-12-10',
                  startTime: '09:00',
                  endDate: '2025-12-10',
                  endTime: '19:00'
                }

                // Google Calendar URL
                const googleCalUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&details=${encodeURIComponent(event.details)}&location=${encodeURIComponent(event.location)}&dates=${event.startDate.replace(/-/g, '')}T${event.startTime.replace(':', '')}00/${event.endDate.replace(/-/g, '')}T${event.endTime.replace(':', '')}00`

                window.open(googleCalUrl, '_blank')
              }}
            >
              <Calendar className="h-4 w-4 mr-2" />
              Add to Calendar
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}